import { render, staticRenderFns } from "./OutData.vue?vue&type=template&id=7f64e7a5&scoped=true&"
import script from "./OutData.ts?vue&type=script&lang=ts&"
export * from "./OutData.ts?vue&type=script&lang=ts&"
import style0 from "./OutData.scss?vue&type=style&index=0&id=7f64e7a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f64e7a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
